<template>
  <main>
    <b-modal
      v-if="isSales || isSPV"
      v-model="showModalBarang"
      id="modal-barang"
      ok-title="Tutup"
      ok-variant="secondary"
      no-close-on-backdrop
      ok-only
      centered
      size="xl"
      title="Cari Barang Untuk Diajukan"
    >
      <!-- Toolbar: checked + search sejajar -->
      <b-row class="mb-2 align-items-center">
        <b-col cols="12" md="5" class="mb-1 mb-md-0">
          <b-button
            variant="success"
            class="d-flex align-items-center"
            :disabled="checkedBarang.length < 1"
            @click.prevent="viewCheckedBarang"
          >
            <feather-icon icon="ShoppingBagIcon" class="mr-1" size="20" />
            <span>{{ checkedBarang.length }} barang dipilih.</span>
          </b-button>
        </b-col>
        <b-col cols="12" md="7">
          <b-input-group size="sm">
            <b-form-input
              id="filterInput"
              v-model="tableBarang.filterText"
              type="search"
              placeholder="Cari nama barang..."
              @keyup.enter="filterBarangMobil"
            />
            <b-input-group-append>
              <b-button :disabled="!tableBarang.filterText" @click="clearFilterBarang">
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <!-- / -->
      <!-- List Barang -->
      <b-table
        striped
        small
        hover
        responsive
        :per-page="tableBarang.perPage"
        :current-page="tableBarang.currentPage"
        :fields="barangFields"
        :items="barangs"
        :filter="tableBarang.filter"
        :filter-included-fields="tableBarang.filterOn"
        @filtered="onBarangFiltered"
      >
        <template #head(checkbox)>
          <b-form-checkbox v-model="allChecked" />
        </template>
        <template #cell(checkbox)="{item}">
          <b-form-checkbox v-model="checkedBarang" :value="item" />
        </template>
        <template #cell(satuan)="{item}">
          <span v-if="!item.konversi || item.konversi.length < 1">
            {{ item.satuan ? item.satuan.satuan : "-" }}
          </span>
          <b-form-select
            v-else
            v-model="item.selectedKonversiId"
            :options="item.konversiOptions"
            @change="recalcKonversi(item)"
          />
        </template>
        <template #cell(stocks)="{item}">
          {{ item.stocks && item.stocks.length > 0 ? item.stocks.reduce((total, stock) => stock.stok > 0 ? total += stock.stok : total += 0, 0) : 0 }} {{ item.satuan ? item.satuan.satuan : '-' }}
        </template>
        <template #cell(qty_request)="{item, index}">
          <b-form-input
            :ref="'qtyRequest-' + index"
            type="number"
            :value="item.qty_request"
            :data-qty-row="index"
            @input="onQtyRequestInput(item, $event)"
            @keydown.up.native.prevent="moveQtyRequest(item, index - 1)"
            @keydown.down.native.prevent="moveQtyRequest(item, index + 1)"
          />
        </template>
        <template #cell(converted)="{item}">
          <strong>
            <template v-if="item.konversi && item.konversi.length > 0">
              {{ displayConverted(item) }}
              <span v-if="displayConverted(item) > 0">
                {{ item.satuan ? item.satuan.satuan.toLowerCase() : "" }}
              </span>
            </template>
            <i v-else class="text-danger">
              <small>Satuan Konversi belum diinput</small>
            </i>
          </strong>
        </template>
      </b-table>
      <!-- / -->
      <!-- Pagination -->
      <b-row>
          <b-col cols="12">
              <b-pagination
                  v-model="tableBarang.currentPage"
                  :total-rows="barangs.length"
                  :per-page="tableBarang.perPage"
                  align="center"
                  size="sm"
                  class="my-0"
              />
          </b-col>
      </b-row>
      <!-- / -->
      <!-- footer -->
      <template #modal-footer>
        <section class="d-flex w-100 justify-content-end">
          
          <b-button @click.prevent="endChooseBarang" variant="info">
            Selesai
          </b-button>
        </section>
      </template>
    </b-modal>
    <b-overlay :show="loading">
      <validation-observer ref="form">

        <!-- two card -->
        <b-row>
          <!-- List barang di penerimaan -->
          <b-col sm="12" md="12">
            <div v-if="isAdminGudang && !isSales && stage >= 3" class="d-flex jutify-content-end mb-2">
              <b-button variant="outline-danger" @click.prevent="printSuratJalan">
                <feather-icon icon="PrinterIcon"></feather-icon>
                Cetak Surat Jalan</b-button>
            </div>
            <b-card>
              <b-row>
                    <b-col md="3" sm="12" class="mb-2">
                        <p><strong>Kode Ajuan Barang</strong></p>
                        <p>
                          <strong>{{rb.no}}</strong>
                        </p>
                    </b-col>
                    <b-col md="3" sm="12" class="mb-2">
                        <p><strong>Status</strong></p>
                        <p>
                          <b-badge :variant="ajuanStatus.color">
                            {{ ajuanStatus.text }}
                          </b-badge>
                        </p>
                    </b-col>
                    <b-col md="3" sm="12" class="mb-2">
                        <p><strong>Tanggal Pengajuan</strong></p>
                        <p>{{ humanDateTime(rb.tanggal_waktu) }}</p>
                    </b-col>
                    <b-col md="3" sm="12" class="mb-2">
                        <p><strong>Nama Sales</strong></p>
                        <p>{{ rb.sales ? rb.sales.nama_lengkap : '-' }}</p>
                    </b-col>
                    <b-col md="6" sm="12" class="mb-2">
                        <p><strong>Keterangan</strong></p>
                        <p>{{rb.keterangan ? rb.keterangan : '-'}}</p>
                    </b-col>
                    <b-col md="6" cols="12" class="mb-2">
                        <p><strong>Rute Ajuan Barang</strong></p>
                        <i class="text-danger" v-if="requestRoute.length < 1">
                          Rute request belum ada
                        </i>
                        <section v-else>
                          <b-badge v-for="(rute, i) in requestRoute" :key="i" variant="light-success" class="mr-1">
                            {{ rute.name }}
                          </b-badge>
                        </section>
                    </b-col>
                </b-row>
            </b-card>
          </b-col>
          <!-- Barang yang sudah disimpan -->
          <b-col cols="12">
            <b-card >
              <header class="d-flex justify-content-between align-items-center flex-wrap mb-1">
                <div>
                  <h3>Rincian Ajuan Barang</h3>
                  <div v-if="isAdminGudang && !isSales && !isMyGudangSelected">
                    <strong class="text-danger">
                      Gudang Anda tidak dipilih untuk pengambilan ajuan barang ini
                    </strong>
                  </div>
                </div>
                
                <div v-if="isAdminGudang && !isSales && stage > 2" class="flex justify-content-end">
                  <b-badge variant="success">
                    Ajuan Ini Sudah Anda Setujui
                  </b-badge>
                </div>
              </header>
              <b-row
                v-if="isAdminGudang && !isSales && stage <= 3"
                class="align-items-center mb-2"
              >
                <b-col cols="12" md="6" class="mb-1 mb-md-0">
                  <b-button
                    size="sm"
                    variant="primary"
                    :disabled="allocatingGudang || rincianBarangs.length < 1 || !isMyGudangSelected"
                    @click.prevent="isiOtomatisSemuaStok"
                  >
                    <b-spinner v-if="allocatingGudang" small class="mr-50" />
                    {{ allocatingGudang ? "Mengisi..." : "Isi otomatis semua" }}
                  </b-button>
                </b-col>
                <b-col cols="12" md="6" class="text-md-right">
                  <small class="text-muted">
                    Sudah dipilih:
                    {{ gudangStockSelectedCount.selected }} /
                    {{ gudangStockSelectedCount.total }}
                  </small>
                </b-col>
              </b-row>
              <b-row>
                <!-- Filter -->
                <b-col cols="12" v-if="isSales || isSPV">
                  <b-row class="justify-content-bet">
                    <b-col md="6" sm="12">
                      <b-button v-if="stage < 3 && this.isSales" variant="info" @click.prevent="openModalBarang">
                        Tambah Barang
                      </b-button>
                    </b-col>
                    <b-col v-if="!isSales && stage != 5" md="6" sm="12" class="d-flex align-items-center">
                      <span class="mr-1">Pilih Gudang</span>
                      <v-select class="w-100" label="text" multiple v-model="selectedGudangs" :options="gudangs" />
                    </b-col>
                  </b-row>
                </b-col>
                <b-col md="2" sm="4" class="my-1">
                  <b-form-group class="mb-0">
                    <label class="d-inline-block text-sm-left mr-50">Per page</label>
                    <b-form-select
                      id="perPageSelect"
                      v-model="perPage2"
                      size="sm"
                      :options="pageOptions2"
                      class="w-50"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="4" sm="8" class="my-1">
                  <b-form-group
                    label="Sort"
                    label-cols-sm="3"
                    label-align-sm="right"
                    label-size="sm"
                    label-for="sortBySelect"
                    class="mb-0"
                  >
                    <b-input-group size="sm">
                      <b-form-select
                        id="sortBySelect"
                        v-model="sortBy2"
                        :options="sortOptions2"
                        class="w-75"
                      >
                        <template v-slot:first>
                          <option value="">-- none --</option>
                        </template>
                      </b-form-select>
                      <b-form-select
                        v-model="sortDesc2"
                        size="sm"
                        :disabled="!sortBy"
                        class="w-25"
                      >
                        <option :value="false">Asc</option>
                        <option :value="true">Desc</option>
                      </b-form-select>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="6" class="my-1">
                  <b-form-group
                    label="Filter"
                    label-cols-sm="3"
                    label-align-sm="right"
                    label-size="sm"
                    label-for="filterInput"
                    class="mb-0"
                  >
                    <b-input-group size="sm">
                      <b-form-input
                        id="filterInput2"
                        v-model="filter2"
                        type="search"
                        placeholder="Type to Search"
                      />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">
                          Clear
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <!-- / -->
                <b-col cols="12">
                  <b-table
                    striped
                    hover
                    responsive
                    :per-page="perPage2"
                    :current-page="currentPage2"
                    :items="rincianBarangs"
                    :fields="rincianFields"
                    :sort-by.sync="sortBy2"
                    :sort-desc.sync="sortDesc2"
                    :sort-direction="sortDirection2"
                    :filter="filter2"
                    :filter-included-fields="filterOn2"
                    @filtered="onFiltered2"
                    >
                    <template #cell(remove)="row">
                      <feather-icon v-if="stage < 3" @click="remove(row)" class="text-danger" size="24" icon="MinusCircleIcon"></feather-icon>
                      <feather-icon v-if="stage == 5" class="text-secondary" size="24" icon="SlashIcon"></feather-icon>
                    </template>
                    <!-- Check box / Pilih Stok for show detail -->
                    <template #cell(details)="row">
                        <template v-if="isAdminGudang && !isSales">
                          <b-button
                            v-if="canGudangPick(row.item) && row.item.stocks && row.item.stocks.length > 0"
                            size="sm"
                            variant="primary"
                            @click.prevent="openPilihStok(row)"
                          >
                            Pilih Stok
                          </b-button>
                          <span v-else class="text-danger">
                            <feather-icon icon="SlashIcon" />
                          </span>
                        </template>
                        <template v-else>
                          <b-form-checkbox
                            v-if="row.item.stocks && row.item.stocks.length > 0"
                            v-model="row.detailsShowing"
                            plain
                            class="vs-checkbox-con"
                            @change="row.toggleDetails"
                          >
                            <span class="vs-checkbox">
                              <span class="vs-checkbox--check">
                                <i class="vs-icon feather icon-check" />
                              </span>
                            </span>
                            <span class="vs-label">{{ row.detailsShowing ? 'Hide' : 'Show' }}</span>
                          </b-form-checkbox>
                          <span v-else class="text-danger">
                            <feather-icon icon="SlashIcon" />
                          </span>
                        </template>
                    </template>
                    <!-- / -->
                    <!-- Detail -->
                    <template #row-details="{item, toggleDetails}">
                    <b-card>
                        <b-row class="mb-2" v-if="isAdminGudang && !isSales">
                          <b-col cols="12" class="d-flex align-items-center mb-1">
                            <b-button
                              size="sm"
                              variant="outline-primary"
                              class="mr-1"
                              @click.prevent="onPilihOtomatis(item)"
                            >
                              Pilih otomatis
                            </b-button>
                            <small class="text-muted">
                              Target SPV: {{ item.spv_request || 0 }}
                              {{ getBarangSatuan(item) }}
                            </small>
                          </b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="12">
                                <table>
                                    <tr>
                                        <th>#</th>
                                        <th>Gudang</th>
                                        <th>Blok</th>
                                        <th>Palet</th>
                                        <th>Rak</th>
                                        <th>Stok</th>
                                        <th>Stok Disetujui Gudang</th>
                                    </tr>
                                    <tr :key="i" v-for="(stock, i) in item.stocks">
                                        <td>
                                          <b-form-checkbox
                                            v-if="getStockAvailableQty(stock) > 0"
                                            :checked="!!stock.selected"
                                            @change="onGudangStockSelected(item, stock, $event)"
                                          />
                                          <feather-icon icon="SlashIcon" class="text-danger" v-else></feather-icon>
                                        </td>
                                        <td>
                                            {{ stock.gudang ? stock.gudang.nama_gudang : '-' }}
                                        </td>
                                        <td>{{ stock.blok ? `Block ${stock.blok.blok}` : '-' }}</td>
                                        <td>{{ stock.palet ? `Palet ${stock.palet.palet}` : '-' }}</td>
                                        <td>{{ stock.rak ? `Rak 1.${stock.rak.rak}` : '-' }}</td>
                                        <td>{{ getStockAvailableQty(stock) }}</td>
                                        <td>
                                            <b-form-input
                                              v-if="getStockAvailableQty(stock) > 0"
                                              type="number"
                                              :value="stock.requestedStock"
                                              @input="onGudangStockQtyInput(item, stock, $event)"
                                            />
                                          <span v-else class="text-danger">
                                            <i>Stok Kosong</i>
                                          </span>
                                        </td>
                                    </tr>
                                </table>
                            </b-col>
                        </b-row>

                        <b-button
                        size="sm"
                        variant="outline-secondary"
                        @click="toggleDetails"
                        >
                        Hide
                        </b-button>
                    </b-card>
                    </template>
                    <!-- / -->
                    <template #cell(actions)="row">
                      <a href="#" v-if="stage < 3" @click.prevent="remove(row)" class="text-danger">
                        <feather-icon icon="MinusCircleIcon" size="24"></feather-icon>
                      </a>
                      <feather-icon v-if="stage == 5" icon="XIcon" class="text-secondary"></feather-icon>
                    </template>
                    <template #cell(no)="{ index }">
                      {{ index + 1 }}
                    </template>

                    <template #cell(barang)="{ item }">
                      {{ item.barang ? item.barang.nama : '-' }}
                    </template>
                    <template #cell(satuan)="{ item }">
                      {{ item.barang && item.barang.satuan ? item.barang.satuan.satuan : '-' }}
                    </template>
                    
                    <template #cell(qty_request)="{item}">
                      <span v-if="isAdminGudang && !isSales">
                        {{ item.qty_request || 0 }}
                        <span v-if="getBarangSatuan(item)">{{ getBarangSatuan(item) }}</span>
                      </span>
                      <span v-else>
                        {{ item.qty_request }}
                      </span>
                    </template>

                    <template #cell(spv_request)="{item}">
                      <span>
                        {{ item.spv_request || 0 }}
                        <span v-if="isAdminGudang && !isSales && getBarangSatuan(item)">
                          {{ getBarangSatuan(item) }}
                        </span>
                      </span>
                    </template>

                    <!-- KHUSUS SPV -->
                    <template v-for="(gudang, i) in selectedGudangs" v-slot:[`cell(${getShortName(gudang.text)})`]="{item}">
                      <b-form-input size="sm" type="number" v-model="item[getShortName(gudang.text)]"></b-form-input>   
                    </template>
                    <!-- / -->

                    <!-- KHUSUS GUDANG / SALES sumStock -->
                    <template #cell(sumStock)="{item}">
                      <template v-if="isAdminGudang && !isSales">
                        <strong>
                          {{ liveApprovedQty(item) }}
                          <span v-if="getBarangSatuan(item)">{{ getBarangSatuan(item) }}</span>
                        </strong>
                        <small
                          v-if="liveApprovedQty(item) < Number(item.spv_request || 0)"
                          class="d-block text-muted"
                        >
                          stok kurang dari request SPV
                        </small>
                      </template>
                      <span v-else>
                        {{ item.tujuan  ? item.tujuan.reduce((total, item) => total += item.qty_real, 0) : 0 }}
                      </span>
                    </template>
                    <!-- / -->

                    <template #cell(appr_spv)="{item}">
                      <span>
                        {{item.appr_spv}}
                      </span>
                    </template>
                    <template #cell(appr_gudang)="{item}">
                      <b-form-input
                        v-if="isAdminGudang"
                        v-model="item.appr_gudang"
                        type="number"
                      />
                      <span v-else>
                        {{item.appr_gudang}}
                      </span>
                    </template>
                    <template #cell(keterangan)="{item}">
                      <b-form-input
                        v-if="isSales || isSPV"
                        v-model="item.keterangan"
                      />
                      <span v-else>{{item.keterangan}}</span>
                    </template>

                  </b-table>
                </b-col>
                <b-col cols="12">
                  <b-pagination
                    v-model="currentPage2"
                    :total-rows="rincianBarangs.length"
                    :per-page="perPage2"
                    align="center"
                    size="sm"
                    class="my-0"
                  />
                </b-col>
              </b-row>
            </b-card>
          </b-col>

          <b-col cols="12" class="mb-4">
            <section class="d-flex justify-content-end">
              <b-button v-if="stage === 4" variant="success" disabled>
                Ajuan Barang Selesai
              </b-button>
              <b-button v-else-if="canGudangApprove" :disabled="rincianBarangs.length < 1 || !isMyGudangSelected" variant="warning" @click.prevent="confirmSubmitStock">Disetujui</b-button>
              <b-button v-else-if="canSalesSubmit" :disabled="rincianBarangs.length < 1" variant="info" @click.prevent="submit">Kirim Ajuan Barang</b-button>
              <b-button v-else-if="canSpvApprove" :disabled="rincianBarangs.length < 1" variant="info" @click.prevent="submit">Disetujui</b-button>
              <b-button v-else-if="canSalesReceive" variant="success" @click.prevent="approveSales">Barang Diterima</b-button>
              <b-button v-if="canCancelAjuan" class="ml-2" variant="outline-danger" @click.prevent="cancel">Batalkan</b-button>
              <b-button v-if="stage === 5" variant="secondary" disabled>Ajuan telah dibatalkan</b-button>
            </section>
          </b-col>
        </b-row>
      </validation-observer>
      <stock-modal :stocks="stocksModal" :rincian_id="rincianIdModal" :barang="barangModal" @submit="addStock"></stock-modal>
      <checked-barang-modal @removeAll="removeCheckedBarang" :stocks="checkedBarang" />
      <preview-stock-modal @submit="submitStock"></preview-stock-modal>
    </b-overlay>
  </main>
</template>

<script>
import CheckedBarangModal from './components/CheckedBarangModal.vue'
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email, confirmed, password } from "@validations";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  BTable,
  VBTooltip,
  BAvatar,
  BBadge,
  BModal,
  BRow,
  BCol,
  BCard,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BFormTextarea, BOverlay,BFormCheckbox, BSpinner
} from "bootstrap-vue";
import vSelect from 'vue-select'
import PreviewStockModal from './components/PreviewStockModal.vue'
import mixin from './mixin'

// Sumber kebenaran status ajuan (selaras backend enum 1..5). Lihat backend/docs/ajuan-barang/PLAN-A-backend.md §7.
const AJUAN_STATUS = {
  1: { text: 'PENDING', color: 'danger' },
  2: { text: 'DISETUJUI SPV', color: 'info' },
  3: { text: 'DISETUJUI GUDANG', color: 'warning' },
  4: { text: 'SELESAI', color: 'success' },
  5: { text: 'DIBATALKAN', color: 'dark' },
}

export default {
  mixins: [mixin],
  components: {
    vSelect,
    PreviewStockModal,
    CheckedBarangModal,
    StockModal: () => import('./components/Modal.vue'),
    BCardActions,
    VBTooltip,
    ToastificationContent,
    BModal,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BFormCheckbox,
    BInputGroupAppend,
    BButton,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    BOverlay,
    BSpinner,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  watch: {
    async selectedGudangs(val) {
      setTimeout(() => {
        this.updateStocks()
      }, 1000)
      this.updateFields()
    },
    allChecked(val) {
      if(val) {
        this.checkedBarang = this.barangs
      }
      else {
        this.checkedBarang = []
      }
    }
  },
  data() {
    return {
      requestRoute: [],
      selectedGudangsId: [],
      deletedGudang: [],
      allChecked: false,
      rincianIdModal: null,
      gudangSales: null,
      gudangs: [],
      selectedGudangs: [],
      checkedBarang: [], // store checkedBarang for insert to rincian
      tableBarang: {
        perPage: 20,
        currentPage: 1,
        filter: '',
        filterText: '',
        filterOn: []
      },
      showModalTambah: false,
      showModalEdit: false,
      form: {
        id:null,
        barang_id:0,
        qty_request:0,
        appr_spv:0,
        keterangan:"",
      },
      rb:{},
      optstatus:[],
      status:{},
      loading: false,
      qtyConvertTimers: {},
      convertedByBarangId: {},
      barangs: [],
      rawBarangs: [],
      perPage: 20,
      pageOptions: [20, 40, 60],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],

      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      barangFields: [
        { key: "checkbox", label: "#" },
        { key: "nama", label: "Nama Barang", sortable: true },
        { key: "stocks", label: "Jumlah Stok", sortable: true },
        { key: "qty_request", label: "Request"},
        { key: "satuan", label: "Satuan" },
        { key: "converted", label: "Jumlah Konversi"}
      ],
      items: [],
      perPage2: 20,
      pageOptions2: [20, 40, 60],
      totalRows2: 1,
      currentPage2: 1,
      sortBy2: "",
      sortDesc2: false,
      sortDirection2: "asc",
      filter2: null,
      filterOn2: [],
      rincianFields: [
        { key: "barang", label: "Barang", sortable: true },
        { key: "qty_request", label: "Request Sales", sortable: true },
        { key: "keterangan", label: "keterangan", sortable: true },
      ],
      templateRincian: [
        {
          appr_spv: 0,
          barang_id: null,
          keterangan: null,
          qty_request: 0,
          request_id: null // defaut route.params.id
        }
      ],
      rawSelectedGudangs: [],
      stocksModal: [], // buat store stock available selected barang oleh gudang
      barangModal: {nama: null}, // buat item barang yg dipilih gudang
      rincianBarangs: [],
      showModalBarang: false,
      status: 1, // status ajun barang
      myCancelPermit: false, // indikasi bahwa current user bisa cancel atau engga
      allocatingGudang: false,
    };
  },
  computed: {
    // Status ajuan sebagai integer 1..5 (server = sumber kebenaran).
    stage() {
      const code = this.rb && (this.rb.status ?? (this.rb.status_data && this.rb.status_data.data_status))
      return Number(code) || 1
    },
    ajuanStatus() {
      return AJUAN_STATUS[this.stage] || AJUAN_STATUS[1]
    },
    // Visibilitas aksi diturunkan dari stage + peran (satu tempat).
    canSalesSubmit() { return this.isSales && this.stage === 1 },
    canSpvApprove() { return this.isSPV && this.stage === 1 },
    canGudangApprove() { return this.isAdminGudang && !this.isSales && this.stage >= 2 && this.stage <= 3 },
    canSalesReceive() { return this.isSales && this.stage === 3 },
    isFinalStage() { return this.stage === 4 || this.stage === 5 },
    canCancelAjuan() { // check apakah ajuan masih bisa dicancel atau engga
      return this.stage <= 3 && this.myCancelPermit == true
    },
    isMyGudangSelected() {
      return this.selectedGudangsId.includes(this.myGudang.id)
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    sortOptions2() {
      // Create an options list from our fields
      return this.rincianFields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    }
  },
  created(){
    this.checkCancelPermission()
    this.getGudangs()
    if(this.isSales) {
      this.getAllStock()
    }
  },
  beforeDestroy() {
    Object.keys(this.qtyConvertTimers || {}).forEach((key) => {
      clearTimeout(this.qtyConvertTimers[key])
    })
    this.qtyConvertTimers = {}
  },
  async mounted() {
    this.loading = true
    // get request barang (detail agregat: header + rute embedded)
    await this.getData()
    await this.setFieldRincian()
    await this.getRincianBarang()
    // get sales gudang
    this.gudangSales = await this.getGudangSales(this.rb)
    this.loading = false
  },
  methods: {
    // boleh pilih stok jika gudang login & belum final & tujuan gudang ini belum di-approve
    canGudangPick(item) {
      if (!(this.isAdminGudang && !this.isSales)) return false
      if (this.stage >= 4) return false
      const myGudangId = this.myGudang ? this.myGudang.id : null
      const tujuan = ((item && item.tujuan) || []).find(t => t.gudang_id === myGudangId)
      return !tujuan || tujuan.appr_gudang !== 1
    },
    cancel() {
      this.$swal({
        title: "Anda yakin?",
        text: `Anda akan membatalkan ajuan barang ini`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Batal",
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger ml-1",
        },
        buttonsStyling: false,    
      })
      .then(async res => {
        if(res.value) {
          this.loading = true
          await this.saveAjuanBarang(5)
          this.loading = false
          this.displaySuccess({
            message: 'Ajuan telah dibatalkan'
          })
          this.$router.push(`/ajuanbarang`)

        }
      })
    },
    async checkCancelPermission() {
      // Batal hanya untuk SPV (sebelumnya: punya m_status_roles data_status=5).
      // Lifecycle header stage <= 3 tetap dicek di canCancelAjuan.
      this.myCancelPermit = !!this.isSPV
    },
    async printSuratJalan() {
      const request_id = this.$route.params.id
      const payload = {
        request_id,
        id_gudang: this.myGudang.id
      }
      try {
        this.loading = true
        // create surat jalan
        const suratJalan = await this.$store.dispatch('requestbarang/createSuratJalan', [payload])

        // download surat jalan
        const params = {
          request_id,
          gudangId: this.myGudang.id
        }
        const response = await this.$store.dispatch('requestbarang/printSuratJalan', params)
        this.loading = false
        window.open(URL.createObjectURL(response))
      }
      catch(e) {
        this.loading = false
        this.displayError(e)
        return false
      }
    },
    filterBarangMobil() {
      const search = String(this.tableBarang.filterText || "").toLowerCase().trim()
      const barangs = this.rawBarangs.slice()
      this.allChecked = false
      if (!search) {
        this.barangs = barangs
        return
      }
      this.barangs = barangs.filter((barang) => {
        const nama = barang.nama ? String(barang.nama).toLowerCase() : ""
        return nama.indexOf(search) > -1
      })
    },
    clearFilterBarang() {
      this.tableBarang.filterText = ""
      this.filterBarangMobil()
    },
    displayConverted(item) {
      if (!item) return 0
      const key = item.id != null ? String(item.id) : null
      if (key != null && Object.prototype.hasOwnProperty.call(this.convertedByBarangId, key)) {
        return this.convertedByBarangId[key]
      }
      return item.converted || 0
    },
    getSelectedKonversi(item) {
      if (!item || !item.konversi || item.konversi.length < 1) return null
      const selectedId = item.selectedKonversiId
      if (selectedId == null || selectedId === "") {
        return item.konversi[0]
      }
      return (
        item.konversi.find(
          (k) => String(k.id) === String(selectedId) || String(k.id_satuan) === String(selectedId)
        ) || item.konversi[0]
      )
    },
    recalcKonversi(item, qtyOverride) {
      if (!item) return

      const qtyRaw =
        qtyOverride !== undefined && qtyOverride !== null
          ? qtyOverride
          : item.qty_request
      const qtyRequest = parseFloat(qtyRaw)
      const selected = this.getSelectedKonversi(item)
      const nilai = selected ? parseFloat(selected.nilai) : NaN

      item.selectedKonversi = selected || null

      let converted = 0
      if (selected && Number.isFinite(qtyRequest) && qtyRequest > 0 && Number.isFinite(nilai)) {
        converted = Math.floor(qtyRequest * nilai)
      }

      this.$set(item, "converted", converted)
      // Map reaktif di root component — b-table pasti ikut re-render slot converted
      if (item.id != null) {
        this.$set(this.convertedByBarangId, String(item.id), converted)
      }
    },
    onQtyRequestInput(item, value) {
      if (!item) return

      const nextQty =
        value !== undefined && value !== null && typeof value !== "object"
          ? value
          : item.qty_request
      this.$set(item, "qty_request", nextQty)

      const key = item.id != null ? String(item.id) : String(item.nama || "")
      if (this.qtyConvertTimers[key]) {
        clearTimeout(this.qtyConvertTimers[key])
      }
      this.qtyConvertTimers[key] = setTimeout(() => {
        this.recalcKonversi(item, item.qty_request)
        this.$delete(this.qtyConvertTimers, key)
      }, 250)
    },
    moveQtyRequest(item, nextIndex) {
      if (item) {
        const key = item.id != null ? String(item.id) : String(item.nama || "")
        if (this.qtyConvertTimers[key]) {
          clearTimeout(this.qtyConvertTimers[key])
          this.$delete(this.qtyConvertTimers, key)
        }
        this.recalcKonversi(item, item.qty_request)
      }
      this.focusQtyRequest(nextIndex)
    },
    focusQtyRequest(index) {
      if (index < 0) return
      this.$nextTick(() => {
        const ref = this.$refs["qtyRequest-" + index]
        const el = Array.isArray(ref) ? ref[0] : ref
        if (!el) return
        const input = el.$el ? el.$el.querySelector("input") || el.$el : el
        if (input && typeof input.focus === "function") {
          input.focus()
          if (typeof input.select === "function") {
            input.select()
          }
        }
      })
    },
    removeCheckedBarang(checkedBarang) {
      this.checkedBarang = checkedBarang
      this.$bvModal.hide('checked-barang-modal')
    },
    viewCheckedBarang() {
      this.$bvModal.show('checked-barang-modal')
    },
    async submitStock(payloads) { // after confirm, update stock
      this.$swal({
        title: "Anda yakin?",
        text: `Stok digudang akan berkurang`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Batal",
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger ml-1",
        },
        buttonsStyling: false,
      })
      .then(async res => {
          if(res.value ) {
      
            try {
              let i = 0
              await payloads.map(async payload => {
                try {
                  // PR JIKA ada yang sudah appr_gudang == 1 defaut jangan submit lagi
                  await this.$store.dispatch('requestbarangrincian/saveApproveGudang', payload)
                  this.displaySuccess({
                    message: 'Stok sudah dipilih'
                  })
                }
                catch(e) {
                  this.displayError(e)
                }
                finally {
                  // push notif supaya notif berkurang
                  const salesPayload = [{
                    karyawan_id: this.rb.sales ? this.rb.sales.id : null,
                    level: 7,
                    modul: 'Ajuan Barang',
                    keterangan: 'Gudang menyetujui Ajuan Barang Sales',
                    id: this.rb.id
                  }]
                  const spvPayload = [{
                    karyawan_id: this.rb.sales ? this.rb.sales.id : null,
                    level: 6,
                    modul: 'Ajuan Barang',
                    keterangan: 'Gudang menyetujui Ajuan Barang Sales',
                    id: this.rb.id
                  }]
                  const datas = [...salesPayload, ...spvPayload]
                  await this.$store.dispatch('notifikasi/save', datas)
                  // send notif to mobile via socket
                  const payload = {
                    key: 'ajuan_barang',
                    value: {
                      level: this.user.level ? this.user.level.id : 0,
                      data: this.rb
                    }
                  }

                  this.eventSocket(payload.key, payload.value)
                }
              })
              
              // reset selected modal
              this.$store.commit('requestbarang/SET_SELECTED_STOCK', [])
              this.$bvModal.hide('form-preview-stock')

              await this.getAjuanBarang()
              
              this.getData()
            }
            catch(e) {
              console.error(e)
              this.displayError(e)
              return false
            }
          }
        })
    },
    async confirmSubmitStock() { // validate and show preview
          const payloads = []
          let error = null

          // Validate payload rincian first
          await this.rincianBarangs.map(rincian => {
            const maxStock = rincian.spv_request
            let payload = {
              nama: rincian.barang ? rincian.barang.nama : null,
              request: maxStock,
              sumStock: 0,
              message: null,
              is_error: false
            }

            // validation if user selected stock less than requestedStock
            const selectedStocks = rincian.stocks.filter(item => item.selected)
            const overStock = selectedStocks.some(
              (item) => this.getStockAvailableQty(item) < Number(item.requestedStock || 0)
            )
            if(overStock) {
              error = 'Pastikan stok yang dipilih memadai request!'
            }
            
            if(rincian.tujuan) {
                
              const rincianTujuan = rincian.tujuan
              rincianTujuan.map(tujuan => { // per barang
                const isMyGudang = tujuan.gudang_id == this.myGudang.id
                if(isMyGudang) {
                  const requestStocks = []
                  if(rincian.stocks && rincian.stocks.length > 0) {

                    rincian.stocks.map(stock => {
                      if(stock.selected) {
                        requestStocks.push(stock)
                      }
                    })
  
                    if(requestStocks.length < 1) {
                      
                      error =  'Harap pilih stok untuk setiap barang!'
                      this.$store.commit('requestbarang/SET_SELECTED_STOCK', [])
                      return false
                    }
  
                    payload.data = {
                      id_request_tujuan: tujuan.id,
                      id_gudang: this.gudangSales ? this.gudangSales.id : null,
                      id_barang: rincian.barang ? rincian.barang.id : null,
                      kirim: requestStocks.map(stock => ({id_penyimpanan: stock.id, qty: parseInt(stock.requestedStock)}))
                    }
  
                    // 
                    const sumRequestStock = payload.data.kirim.reduce((total, item) => total += item.qty, 0)
                    if(sumRequestStock > maxStock) {
                      payload.is_error = true
                      payload.message = 'Pilihan stok melebihi dari request'
                    }
                    payload.sumStock = payload.data.kirim.reduce((total, item) => total += item.qty, 0)
        
                    // send to paylods
                    payloads.push(payload)
                  }
                }
              })
            }
          })

          if(error) {
            this.displayError({
              message: error
            })
            return false
          }

          // save to store and open the preview modal
          this.$store.commit('requestbarang/SET_SELECTED_STOCK', payloads)
          this.$bvModal.show('form-preview-stock')

    },
    async getAjuanBarang() {
      let params = this.isSales ? { sales_id: this.user.karyawan.id, order: 'desc' } : {order: 'desc'}
      if(this.isAdminGudang) {
        params.order_status = 'desc'
      }
      
      if(this.selectedStatus && this.selectedStatus != 'all') {
        params.status = this.selectedStatus
      }
      this.loading = true
      await this.$store.dispatch('requestbarang/getData', params)
      this.loading = false
    },
    addStock({selectedStocks, rincian_id}) {
      const rincianBarangs = JSON.parse( JSON.stringify(this.rincianBarangs) )
      rincianBarangs.map(async rincian => {
        if(rincian.id == rincian_id) {
          // rincian.sumStock = await selectedStocks.reduce((total, item) => total += item.jumlah, 0)
          rincian.sumStock = selectedStocks[selectedStocks.length - 1].jumlah
          rincian.stocks = selectedStocks
        }
      })
      this.rincianBarangs = rincianBarangs
      this.$bvModal.hide('stock-modal')
    },
    // Gudang memilih stok untuk setiap barang
    async pilihStock(rincian) {
      this.stocksModal = []
      this.barangModal = {nama:null}
      this.rincianIdModal = null

      // get stock per barang
      const barang = rincian.barang ? rincian.barang : null
      if(!barang) {
        this.displayError({
          message: 'Barang tidak ada di rincian'
        })
        return false
      }

      const stocks = await this.$store.dispatch('penyimpanan/getData', {
        barang_id: barang.id,
        gudang_id: this.myGudang.id
      })
      this.stocksModal = stocks
      this.barangModal = barang
      this.rincianIdModal = rincian.id
      this.$bvModal.show('stock-modal')
    },
    updateFields() {
      let rincianFields = [
          { key: "actions", label: "" }, 
          { key: "barang", label: "Barang", sortable: true },
          { key: "satuan", label: "Satuan" },
          { key: "qty_request", label: "Request Sales", sortable: true }
      ]
      
      if(this.selectedGudangs.length > 0) {
        this.selectedGudangs.map(gudang => {
          const newItem = {
            key: this.getShortName(gudang.text),
            label: gudang.text
          }
          rincianFields.push(newItem)
        })
      }

      rincianFields.push({ key: "keterangan", label: "keterangan", sortable: true })

      setTimeout(() => {
        this.rincianFields = rincianFields
      }, 500)
      
    },
    updateStocks() { // ketika SPV memilih gudang, munculkan stock per gudang dari list barang rincian
      if(this.selectedGudangs.length > 0 && this.rincianBarangs.length > 0) {

        // function untuk menyamakan stock berlebih dengan request sales
        function getSelisih(requestSales, target, stock) {
          for(let i = 0; i < stock; i++) {
            if(requestSales < target) {
              requestSales++
            }
          }

          return requestSales
        }

        // get barang rincian id
        const barangsId = this.rincianBarangs.map(rincian => rincian.barang ? rincian.barang.id : null).filter(item => item != null)
        
        // call api
        this.selectedGudangs.map(async (gudang, index_gudang) => {
          const stocks = await this.$store.dispatch('penyimpanan/getData', {
            barang_id: barangsId.join(','),
            gudang_id: gudang.value
          })
          this.rincianBarangs.map(rincian => {
            rincian.penyimpanan = []
            const stockCurrentBarang = stocks.filter(stock => (stock.barang && rincian.barang) && stock.barang.id == rincian.barang.id)
            const stockPenyimpanans = []
            const sumStockCurrentBarang = stockCurrentBarang.reduce((total, item) => total += item.jumlah, 0)
            
            // Menentukan request sales
            let requestSales = 0
            rincian[ this.getShortName(gudang.text) + '_jumlah' ] = stockCurrentBarang.reduce((total, item) => total += item.stok, 0)
            
            stockCurrentBarang.map(stock => {
              // requestSales += stock.jumlah
              if(requestSales < rincian.qty_request) {
                const res = requestSales + stock.stok
                if(res >= rincian.qty_request) {
                  requestSales = getSelisih(requestSales, rincian.qty_request, stock.stok)
                }
                else{
                  requestSales += stock.stok
                }
              }
            })
            rincian[ this.getShortName(gudang.text) ] = rincian[ this.getShortName(gudang.text) ] ? rincian[ this.getShortName(gudang.text) ] : requestSales
          })

          if(index_gudang == this.selectedGudangs.length - 1) {
            const updatedRincian = Object.assign([], this.rincianBarangs)
            this.rincianBarangs = []
            this.rincianBarangs = updatedRincian
          }
        })
      }
    },
    approveSales() { // untuk sales menandai bahwa request nya sudah sesuai dan agar masuk ke stock mobil
      this.$swal({
        title: "Anda yakin?",
        text: "Anda akan menandai selesai ajuan barang ini",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Batal",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false
      })
      .then(async res => {
        if(res.value) {
          try {
            this.loading = true
            // send to approve sales
            let payloadTujuan = []
            this.rincianBarangs.map(rincian => {
              if(rincian.tujuan) {
                rincian.tujuan.map(tujuan => {
                  payloadTujuan.push({
                    id_request_tujuan: tujuan.id
                  })
                })
              }
            })
            const response = await this.$store.dispatch('requestbarangrincian/approveSales', payloadTujuan)
            const key = 'ajuan_barang'
            const value = {
              level: this.user.level.id,
              data: response
            }

            this.eventSocket(key, value)
            
            this.loading = false
            this.displaySuccess({
              message: 'Data berhasil disimpan'
            })
            setTimeout(() => {
              this.$router.push('/ajuanbarang')
            }, 100)
          }
          catch(e) {
            this.loading = false
            this.displayError(e)
            return false
          }
        }
      })
      

    },
    async saveAjuanBarang(status = 1) {
      const payload = this.rb
      payload.status = status // DISETJUI SPV
      const response = await this.$store.dispatch('requestbarang/save', [payload])
      return Promise.resolve(response.data)
    },
    async getRincianBarang() {
      await this.$store.dispatch("requestbarangrincian/getData", {request_id: this.$route.params.id})

      //  get data rincian
      let listRequestedBarangs = this.$store.state.requestbarangrincian.datas
      if(this.isAdminGudang || this.isSales) {
       listRequestedBarangs = await this.setRincianDetail(listRequestedBarangs)
       this.selectedGudangsId = await this.getSelectedGudang(listRequestedBarangs)
       
      }
      else { // spv
        // set for detail like gudang1 => 10, gudang2 => 23
        listRequestedBarangs = this.setRincianGudang(listRequestedBarangs)
      }

      // Normalize + allocate while stocks are already loaded (setRincianDetail now awaits).
      // Do this before binding so the table never flashes approvedQty 0.
      listRequestedBarangs.forEach((rincian) => {
        if (rincian.stocks) {
          rincian.stocks.forEach((stock) => {
            if (stock.stok == null && stock.jumlah != null) {
              stock.stok = stock.jumlah
            }
            stock.selected = false
            stock.requestedStock = 0
          })
        }
        rincian.approvedQty = 0
      })

      if (this.isAdminGudang && !this.isSales) {
        listRequestedBarangs.forEach((rincian) => {
          this.autoAllocateStock(rincian)
        })
      } else {
        listRequestedBarangs.forEach((rincian) => {
          if (!rincian.stocks) return
          rincian.stocks.forEach((stock) => {
            const available = this.getStockAvailableQty(stock)
            let qty =
              rincian.qty_request > available ? available : rincian.qty_request
            if (rincian.tujuan) {
              qty = rincian.tujuan.reduce(
                (total, tj) => total + (Number(tj.qty_real) || 0),
                0
              )
            }
            stock.requestedStock = qty
          })
        })
      }

      this.rincianBarangs = listRequestedBarangs
      this.totalRows2 = listRequestedBarangs.length
    },
    openPilihStok(row) {
      if (!row || !row.item) return
      const item = this.resolveRincianItem(row.item)
      const hasSelected = (item.stocks || []).some((s) => s.selected)
      if (!hasSelected) {
        this.autoAllocateStock(item)
      } else {
        this.syncApprovedQty(item)
      }
      if (!row.detailsShowing && typeof row.toggleDetails === 'function') {
        row.toggleDetails()
      }
    },
    resolveRincianItem(item) {
      if (!item || !this.rincianBarangs || this.rincianBarangs.length < 1) {
        return item
      }
      if (item.id == null) return item
      return this.rincianBarangs.find((r) => r && r.id === item.id) || item
    },
    /** Live sum for table cell — depends on selected + requestedStock so UI stays in sync. */
    liveApprovedQty(item) {
      const rincian = this.resolveRincianItem(item)
      const stocks = (rincian && rincian.stocks) || []
      return stocks.reduce((total, stock) => {
        if (!stock.selected) return total
        const qty = parseInt(stock.requestedStock, 10)
        return total + (Number.isFinite(qty) && qty > 0 ? qty : 0)
      }, 0)
    },
    onGudangStockQtyInput(item, stock, value) {
      // Apply value first (avoid v-model/@input race leaving approvedQty stale)
      const next =
        value === '' || value == null
          ? 0
          : typeof value === 'object' && value.target
            ? value.target.value
            : value
      const rincian = this.resolveRincianItem(item)
      const realStock =
        ((rincian && rincian.stocks) || []).find(
          (s) => s && stock && s.id != null && s.id === stock.id
        ) || stock
      this.$set(realStock, 'requestedStock', next)
      if (!realStock.selected && Number(next) > 0) {
        this.$set(realStock, 'selected', true)
      }
      this.syncApprovedQty(rincian)
      // b-table parent cells often miss nested stock updates without a force
      this.$forceUpdate()
    },
    onGudangStockSelected(item, stock, checked) {
      const isChecked =
        typeof checked === 'boolean'
          ? checked
          : !!(checked && checked.target ? checked.target.checked : checked)
      const rincian = this.resolveRincianItem(item)
      const realStock =
        ((rincian && rincian.stocks) || []).find(
          (s) => s && stock && s.id != null && s.id === stock.id
        ) || stock
      this.$set(realStock, 'selected', isChecked)
      this.syncApprovedQty(rincian)
      this.$forceUpdate()
    },
    onPilihOtomatis(item) {
      this.autoAllocateStock(this.resolveRincianItem(item))
      this.$forceUpdate()
    },
    isiOtomatisSemuaStok() {
      if (this.allocatingGudang) return
      this.allocatingGudang = true
      this.$nextTick(() => {
        try {
          this.autoAllocateAllRincian()
          this.displaySuccess({
            message: 'Stok berhasil dialokasikan otomatis',
          })
        } finally {
          this.allocatingGudang = false
        }
      })
    },
    getMergeGudang() {
      const result = Object.assign([], this.rawSelectedGudangs)
      this.selectedGudangs.map(gd => {
        if(!result.find(item => item.value == gd.value)) {
          result.push(gd)
        }
      })

      return result
    },
    async saveRincianTujuan() {
      if(this.isSPV || this.isAdminGudang) {
  
        // check first for get id tujuan if exist
        const tujuans = await this.$store.dispatch('requestbarangrincian/getTujuan', {
          rincian_request_id: this.rincianBarangs.map(rincian => rincian.id).join(',')
        })
  
        const payloads = []
        const payloadsApprove = []
        const mergeSelectedGudangs = this.getMergeGudang()
        mergeSelectedGudangs.map(async gudang => {

          const gudangKey = this.getShortName(gudang.text)
          this.rincianBarangs.map(rincian => {
            const hasTujuan = tujuans.find(tujuan => tujuan.rincian_request_id == rincian.id && tujuan.gudang_id == gudang.value)
            let payload = {
              rincian_request_id: rincian.id,
              gudang_id: gudang.value,
              qty_request: rincian[gudangKey],
              appr_gudang: 0,
              appr_sales: 0,
              qty_real: 0,
              keterangan: rincian.keterangan ? rincian.keterangan : '-'
            }
            if(hasTujuan) {
              payload.id = hasTujuan.id // tujuan id
            }

            if(this.deletedGudang.find(dl => dl.value == gudang.value)) {
              payload.fungsi = 2
            }

            payloads.push(payload)
          })
        })
        // start insert
        try {
            await this.$store.dispatch('requestbarangrincian/saveTujuan', payloads)
            setTimeout(() => this.$router.push('/ajuanbarang'), 1000)
        }
        catch(e) {
          this.displayError(e)
          return false
        }
  
      }
    },
    async getAllStock() { // khusus untuk sales ambil semua stock
      const stocks = await this.$store.dispatch('penyimpanan/getData')
      const barangs = []

      // get barang data
      stocks.map(item => {
        const find = barangs.find(barang => item.barang && barang.id == item.barang.id)
        if(!find) {
          let barang = item.barang
          if(barang) {
            barang.stocks = []
            barang.qty = 0
            barangs.push(barang)
          }
        }
      })

      barangs.map(barang => {
        barang.qty_request = 0
        barang.converted = 0
        const barangStocks = stocks.filter(stock => stock.barang && stock.barang.id == barang.id)
        
        if(barangStocks) {
          barangStocks.map(stock => {
            delete stock.barang
            barang.stocks.push(stock)
          })
        }

        if (barang.konversi && barang.konversi.length > 0) {
          barang.konversiOptions = barang.konversi.map((konversi) => ({
            value: konversi.id,
            text: konversi.satuan ? konversi.satuan.satuan : String(konversi.id_satuan),
          }))
          barang.selectedKonversiId = barang.konversiOptions[0].value
          barang.selectedKonversi = barang.konversi[0]
        } else {
          barang.konversiOptions = []
          barang.selectedKonversiId = null
          barang.selectedKonversi = null
        }
      })

      this.convertedByBarangId = {}
      this.barangs = barangs
      this.rawBarangs = barangs
    },
    async getGudangs() {
      const gudangs = await this.$store.dispatch('gudang/getData', {jenis: 1})
      gudangs.map(gudang => {
        this.gudangs.push({
          value: gudang.id,
          text: gudang.nama_gudang
        })
      })
    },
    setFieldRincian() {
      if(this.isSales) {
        if(this.stage == 3) {
          this.rincianFields = this.rincianSalesFields
        }
        else {
          this.rincianFields = this.rincianDefaultFields
        }
      }
      else if(this.isSPV){
        this.rincianFields = this.rincianSpvFields
      }
      else {
        this.rincianFields = this.rincianGudangFields
      }
    },
    endChooseBarang() {
      this.checkedBarang.forEach((brg) => {
        this.recalcKonversi(brg, brg.qty_request)
        const selected = this.getSelectedKonversi(brg)
        const qtyRequest = brg.konversi && brg.konversi.length > 0 && selected
          ? this.displayConverted(brg)
          : brg.qty_request
        const qtyNum = Number(qtyRequest) || 0
        const existing = this.rincianBarangs.find(
          (r) => r.barang && r.barang.id === brg.id,
        )

        if (existing) {
          this.$set(
            existing,
            'qty_request',
            (Number(existing.qty_request) || 0) + qtyNum,
          )
        } else {
          this.rincianBarangs.push({
            barang: {
              id: brg.id,
              nama: brg.nama,
              satuan: brg.satuan,
            },
            appr_spv: 0,
            keterangan: null,
            qty_request: qtyNum,
            request: this.rb,
          })
        }

        this.$set(brg, 'qty_request', 0)
        this.$set(brg, 'converted', 0)
        this.recalcKonversi(brg, 0)
      })

      this.showModalBarang = false
      this.checkedBarang = []
      this.allChecked = false
    },
    onBarangFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length;
        this.tableBarang.currentPage = 1;
    },
    getTotal(stocks) {
      return stocks.reduce((total, item) => item.jumlah + total, 0)
    },
    openModalBarang() {
      // default checklist all
      this.allChecked = true
      this.showModalBarang = true
      
    },
    remove({index, item}) {
      const isNewData = item.id ? false : true
      if(isNewData) {
        this.rincianBarangs.splice(index, 1)
      }
      else { // delete to API

        this.$swal({
          title: "Anda yakin?",
          text: `Data Rincian Ajuan Barang ini akan dihapus`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Batal",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            item.fungsi = 1; // soft delete
            this.$store
              .dispatch("requestbarangrincian/save", [item])
              .then(() => {
                this.resetForm();
                this.getData();
                this.getRincianBarang();
              })
              .catch((e) => {
                this.displayError(e);
                return false;
              });
          }
        });
      }
    },
    resetForm() {
      this.form.barang_id = null;
      this.form.qty_request = null;
      this.form.keterangan = null;
      this.showModalTambah = false;
      this.showModalEdit = false;
    },
    edit(item) {
      let { id } = item;
      this.form.barang_id = id;
      this.showModalEdit = true;
    },
    getDeletedGudang() {
      const result = []
      this.rawSelectedGudangs.map(item => {
        if(!this.selectedGudangs.find(gd => gd.value == item.value)) {
          result.push(item)
        }
      })

      return result
    },
    submit() {

      if(this.isSPV ) {
        // check if selected gudang was removed
        this.deletedGudang = this.getDeletedGudang()


        if(this.selectedGudangs.length < 1) {
          this.displayError({
            message: 'Harap Pilih Gudang Penyimpanan!'
          })

          return false
        }

        // if spv, validasi jangan ada nol
        let emptyStockGudang = []
        this.selectedGudangs.map(gudang => {
          const key = this.getShortName(gudang.text)
          const emptyStocks = this.rincianBarangs.filter(rincian => rincian[key] < 1)
          if(emptyStocks.length > 0) {
            emptyStockGudang = emptyStockGudang.concat(emptyStocks)
          }
        })

        if(emptyStockGudang.length > 0) {
          this.displayError({
            message: 'Stok Barang di gudang yang dipilih tidak boleh kosong!'
          })
          return false
        }
      }

      this.$swal({
        title: "Anda yakin?",
        text: "Anda akan menyetujui ajuan barang ini",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Batal",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false
      })
      .then(res => {
        if(res.value) {
          // check if selected gudang was deleted
          this.rawSelectedGudangs.map(item => {
            if(!this.selectedGudangs.find(gd => gd.value == item .value)) {
              this.deletedGudang.push(item)
            }
          })
          // set payloads
          let payloads = []
    
          // set payload of update for request tujuan dan approve gudang endpoint
          let tujuanPayload = []
          this.rincianBarangs.map(rincian => {
            let payload = {
              barang_id: rincian.barang.id,
              appr_spv: this.isSales && (status == null || status == 1) ? 0 : 1,
              appr_sales: 0,
              qty_request: rincian.qty_request,
              keterangan: rincian.keterangan ? rincian.keterangan : '-',
              request_id: rincian.request.id
            }
            if(rincian.id) {
              payload.id = rincian.id
            }
            payloads.push(payload)
          })
    
          this.loading = true
    
          this.$store
            .dispatch("requestbarangrincian/save", payloads)
            .then(async () => {
              this.loading = false
              this.checkedBarang = []
              
              if(this.isSPV) {
                this.status = 2
                // send to tujuan
                const response = await this.saveAjuanBarang(this.status)
                await this.saveRincianTujuan()

                // send notif to mobile via socket
                const payload = {
                  key: 'ajuan_barang',
                  value: {
                    level: this.user.level ? this.user.level.id : 0,
                    data: response
                  }
                }

                this.eventSocket(payload.key, payload.value)
              }
              else if(this.isAdminGudang) {
                this.status = 3
              }
              
              this.rincianBarangs = []
              await this.getRincianBarang()
              this.setFieldRincian()
              this.displaySuccess({
                message: 'Berhasil'
              })
            })
            .catch((e) => {
              this.loading = false
              this.displayError(e)
              console.error(e)
              return false
            });
        }
      })
    },
    add(item) {
      let { id } = item;
      this.id = id;
      this.showModalTambah = true;
    },
    getTotal(stocks) {
      return stocks.reduce((total, item) => item.jumlah + total, 0);
    },
    async getStockBarang(barangsId) {
      const params = {barang_id: barangsId.join(',')}
      const stocks = await this.$store.dispatch('penyimpanan/getData', params)

      // add stocks to data barang
      this.barangs.map(barang => {
        barang.stocks = []
        const findStocks = stocks.filter(stock => stock.barang && stock.barang.id == barang.id)

        if(findStocks && findStocks.length > 0) {
            findStocks.forEach(stock => {
                barang.stocks.push({
                    id: stock.id,
                    jumlah: stock.jumlah,
                    gudang: stock.gudang,
                    blok: stock.blok,
                    rak: stock.rak,
                    laci: stock.laci
                })
            })
        }
      })
    },
    viewDetail(item) {
      this.$store.commit("penyimpanan/SET_DETAIL_DATA", item);
      setTimeout(
        () => this.$router.push({ name: "route-stock-in-edit", params: { id: item.id } }),
        500
      );
    },
    async getData() {
        const rb = await this.$store.dispatch("requestbarang/getDataById", this.$route.params.id)
        this.rb = rb
        // rute sudah embedded di detail agregat (hindari call terpisah)
        this.requestRoute = (rb && Array.isArray(rb.rute) ? rb.rute : []).map(r => ({
          name: r.nama_rute,
        }))
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFiltered2(filteredItems2) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows2 = filteredItems2.length;
      this.currentPage2 = 1;
    },
  }
};
</script>
